import Accordion from '@/molecules/Accordion/Accordion';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledTitle = styled.p`
  ${typography.Subtitle1}
  margin-bottom: ${sizePx(10)};
`;

export const StyledBody = styled.div`
  ${typography.Body1}
`;

export const StyledAccordion = styled(Accordion)`
  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;

export const StyledAboutBio = styled.div`
  display: none;
  @media only screen and ${breakpoints.device.m} {
    display: block;
  }
`;
